export default __webpack_public_path__ + "static/media/Drag.075b42ad.svg";